import { create } from "zustand";
import type { QuoteStatus } from "@school-sales-ai/shared";

/**
 * The /cotizaciones filter bar. Its own store, not `crm.store` or
 * `orders.store`: a search typed in one list must never narrow another behind
 * someone's back. In memory only — there is no view mode to remember yet.
 */
type QuotesState = {
  search: string;
  /** Multi-select, OR'd. Empty = everything the team can act on. */
  statuses: QuoteStatus[];
  page: number;
  setSearch: (value: string) => void;
  toggleStatus: (status: QuoteStatus) => void;
  clearStatuses: () => void;
  setPage: (page: number) => void;
};

export const useQuotesStore = create<QuotesState>((set) => ({
  search: "",
  statuses: [],
  page: 1,
  // Every filter change returns to the first page, or a narrowed list can open
  // on a page past its end.
  setSearch: (search) => set({ search, page: 1 }),
  toggleStatus: (status) =>
    set((s) => ({
      statuses: s.statuses.includes(status)
        ? s.statuses.filter((x) => x !== status)
        : [...s.statuses, status],
      page: 1,
    })),
  clearStatuses: () => set({ statuses: [], page: 1 }),
  setPage: (page) => set({ page }),
}));
